/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function e(e,{repeat:o,repeatType:p="loop"}){return e[o&&"loop"!==p&&o%2==1?0:e.length-1]}export{e as getFinalKeyframe};
//# sourceMappingURL=get-final-keyframe.js.map
